/* CreateQuestionComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./CreateQuestionRenderer");

class CreateQuestionComponent extends EventEmitter {
    constructor(logger, paths, selectedSite) {
        super();
        this._logger = logger;
        this._titleText = "Create Site";
        this._placeHolderTitle = "";
        this._paths = paths;
        this._selectedSite = selectedSite || "";
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    get titleText() {
        return this._titleText;
    }
    get logger() {
        return this._logger;
    }
    get isMessageProvided() {
        return this.message ? true : false;
    }
    get placeHolderTitle() {
        return this._placeHolderTitle;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
                this._titleText = undefined;
                this._placeHolderTitle = undefined;
                this._context = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "SiteCreateComponent.shutdown() error");
            }
        );
    }
    createAction(data) {
        this._context.resolve(data);
    }
    cancelAction() {
        this._context.reject({userRejected: true});
    }
    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}
module.exports = CreateQuestionComponent;
